/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_L1_Point_0_LabelInputs */

const en_visa_l1_point_0_label = /** @type {(inputs: Visa_L1_Point_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corporate Structure`)
};

const pt_visa_l1_point_0_label = /** @type {(inputs: Visa_L1_Point_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrutura Corporativa`)
};

const es_visa_l1_point_0_label = /** @type {(inputs: Visa_L1_Point_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estructura Corporativa`)
};

/**
* | output |
* | --- |
* | "Corporate Structure" |
*
* @param {Visa_L1_Point_0_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_l1_point_0_label = /** @type {((inputs?: Visa_L1_Point_0_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_L1_Point_0_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_l1_point_0_label(inputs)
	if (locale === "es") return es_visa_l1_point_0_label(inputs)
	return en_visa_l1_point_0_label(inputs)
});